/* TM Scroll Cover Effect v4 */
(function () {
  if (window.location.pathname !== '/') return;

  var SLIDE_ID = 'shopify-section-slideshow-1';

  function init() {
    var slideWrap = document.getElementById(SLIDE_ID) ||
                   document.querySelector('[id^="shopify-section-slideshow"]');
    if (!slideWrap) return;

    var slideH = slideWrap.offsetHeight;

    setProp(slideWrap, 'position', 'relative');
    setProp(slideWrap, 'z-index', '1');

    /* All template sections after the slideshow */
    var candidates = Array.prototype.slice.call(
      document.querySelectorAll(
        '#MainContent > .shopify-section,' +
        '#MainContent > div > .shopify-section,' +
        '#MainContent > div > div > .shopify-section'
      )
    );

    var foundSlide = false;
    var coverIndex = 0;
    candidates.forEach(function (el) {
      if (el.id === slideWrap.id) { foundSlide = true; return; }
      if (!foundSlide) return;
      setProp(el, 'position', 'relative');
      setProp(el, 'z-index', String(10 + coverIndex));
      applyBg(el, '#FDFAF6');
      if (coverIndex === 0) {
        setProp(el, 'border-radius', '20px 20px 0 0');
        setProp(el, 'box-shadow', '0 -12px 40px rgba(0,0,0,0.22)');
        setProp(el, 'overflow', 'hidden');
        setProp(el, 'margin-top', '-24px');
      }
      coverIndex++;
    });

    /* Footer group wrapper — force dark bg */
    var footerSelectors = [
      '.shopify-section-group--footer-group',
      '#shopify-section-group-footer-group',
      '[id*="shopify-section-group-footer"]'
    ];
    footerSelectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        setProp(el, 'position', 'relative');
        setProp(el, 'z-index', '60');
        /* Don't override bg here — let individual child sections
           carry their own correct backgrounds (#F5EDE3 bar + #1A1A1A footer) */
      });
    });

    /* Force bg on individual footer child sections */
    var footerChildren = document.querySelectorAll(
      '.shopify-section-group--footer-group > .shopify-section,' +
      '#shopify-section-group-footer-group > .shopify-section,' +
      '[id*="shopify-section-group-footer"] > .shopify-section'
    );
    footerChildren.forEach(function (el) {
      var id = el.id || '';
      if (id.indexOf('tm-free-shipping-bar') !== -1) {
        /* Cream shipping bar — preserve its own bg */
        el.style.setProperty('background-color', '#F5EDE3', 'important');
        el.style.setProperty('background', '#F5EDE3', 'important');
      } else {
        /* Dark footer sections */
        var computed = window.getComputedStyle(el).backgroundColor;
        if (isTransparent(computed)) {
          el.style.setProperty('background-color', '#1A1A1A', 'important');
          el.style.setProperty('background', '#1A1A1A', 'important');
        }
      }
      setProp(el, 'position', 'relative');
      setProp(el, 'z-index', '61');
    });

    /* Also force the actual footer element inside */
    var siteFooter = document.querySelector('footer.site-footer, .site-footer');
    if (siteFooter) {
      siteFooter.style.setProperty('background-color', '#1A1A1A', 'important');
      siteFooter.style.setProperty('background', '#1A1A1A', 'important');
      siteFooter.style.setProperty('position', 'relative', 'important');
      siteFooter.style.setProperty('z-index', '61', 'important');
    }

    /* Spacer */
    var spacer = document.createElement('div');
    spacer.id = 'tm-cover-spacer';
    spacer.style.cssText = 'height:' + slideH + 'px;display:none;width:100%;pointer-events:none;flex-shrink:0;';
    slideWrap.parentNode.insertBefore(spacer, slideWrap);

    var isFixed  = false;
    var headerH  = getHeaderHeight();
    var slideTop = getOffset(slideWrap);

    function onScroll() {
      var scrollY  = window.pageYOffset || window.scrollY;
      var triggerY = slideTop - headerH;
      if (!isFixed && scrollY >= triggerY) {
        isFixed = true;
        slideWrap.style.setProperty('position', 'fixed', 'important');
        slideWrap.style.setProperty('top', headerH + 'px', 'important');
        slideWrap.style.setProperty('left', '0', 'important');
        slideWrap.style.setProperty('width', '100%', 'important');
        slideWrap.style.setProperty('z-index', '1', 'important');
        spacer.style.display = 'block';
      } else if (isFixed && scrollY < triggerY) {
        isFixed = false;
        slideWrap.style.removeProperty('position');
        slideWrap.style.removeProperty('top');
        slideWrap.style.removeProperty('left');
        slideWrap.style.removeProperty('width');
        slideWrap.style.setProperty('z-index', '1', 'important');
        spacer.style.display = 'none';
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function setProp(el, prop, val) {
    el.style.setProperty(prop, val, 'important');
  }

  function applyBg(el, color) {
    var computed = window.getComputedStyle(el).backgroundColor;
    if (isTransparent(computed)) {
      el.style.setProperty('background-color', color, 'important');
      var inner = el.querySelector('div, section');
      if (inner && isTransparent(window.getComputedStyle(inner).backgroundColor)) {
        inner.style.setProperty('background-color', color, 'important');
      }
    }
  }

  function isTransparent(val) {
    return !val || val === 'transparent' || val === 'rgba(0, 0, 0, 0)' || val === 'rgba(0,0,0,0)';
  }

  function getOffset(el) {
    var top = 0;
    while (el) { top += el.offsetTop || 0; el = el.offsetParent; }
    return top;
  }

  function getHeaderHeight() {
    var h = document.querySelector('header, .site-header, #shopify-section-header');
    return h ? h.offsetHeight : 0;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(init, 300); });
  } else {
    setTimeout(init, 300);
  }
})();
